/**
 * desktopDetection.ts — Detect if running in a desktop app wrapper (Tauri, Electron, etc).
 *
 * Abstracted as `isDesktopApp()` so switching to Electron later only requires
 * changing this file.
 *
 * Two signals, because neither is enough on its own:
 *
 * - `window.__TAURI__` is only injected when `app.withGlobalTauri` is true in
 *   tauri.conf.json. It was false here for a long time, which made this
 *   function quietly return false inside the desktop app.
 * - The origin is always there, but differs per platform: macOS and Linux get
 *   `tauri://localhost`, Windows gets `http://tauri.localhost`. The Windows
 *   form is a plain http origin whose *host* is what gives it away.
 */

/** Hosts the Tauri shell serves the app from. Keep in step with the server's DESKTOP_SHELL_HOSTS. */
const TAURI_HOSTS = ["tauri.localhost"]

export function isTauriDesktop(): boolean {
  if (typeof window === "undefined") return false
  if ("__TAURI__" in window || "__TAURI_INTERNALS__" in window) return true
  return (
    window.location.protocol === "tauri:" ||
    TAURI_HOSTS.includes(window.location.hostname)
  )
}

export function isDesktopApp(): boolean {
  return isTauriDesktop()
}
